import React, { Component } from "react";
import requester from "../../lib/requester";
import axios from "axios";
import { Loader } from "react-overlay-loader";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from "moment";

class Unidentified extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(window.localStorage.getItem("is_user")),
      dataTable: [],
    };
  }

  componentDidMount = () => {
    this.getList();
  };

  getList = () => {
    // let url = "https://api-digifin.dexagroup.com/collection/dev/v1/traces/unidentified";
    let url = `${process.env.REACT_APP_COLLECTION_URL}/v1/traces/unidentified`;
    let options = {
      url: url,
      method: "GET",
      headers: {
        "api-key": process.env.REACT_APP_COLLECTION_API_KEY,
        Authorization: "Bearer " + process.env.REACT_APP_COLLECTION_TOKEN,
      },
    };

    let app = this;
    axios(options)
      .then((response) => {
        let { data } = response.data;
        app.setState({ dataTable: data.data, loading: false });
      })
      .catch((e) => {
        app.setState({ loading: false });
      });
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "KWITANSI NO",
          accessor: "NO_KWITANSI",
          filterable: true,
        },
        {
          Header: "CUSTOMER ID",
          accessor: "CUSTOMER_ID",
          filterable: true,
        },
        {
          Header: "CUSTOMER NAME",
          accessor: "CUSTOMER_NAME",
          filterable: true,
        },
        {
          Header: "MATCH DATE",
          accessor: "MATCH_DATE",
          filterable: true,
          Cell: function (row) {
            return (
              <span>{moment(row.value).format("DD-MMM-YYYY HH:mm:ss")}</span>
            );
          },
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = "";
          switch (filter.id) {
            case "1":
              columnes = row._original.formatted_start_date;
              break;
            default:
              columnes = row[filter.id];
          }
          console.log(columnes);

          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Unidentified;
